import { iTrack } from '../types/ITrack';
import { generateTrackID } from './generateTrackID';
export const ensureTrackId = (track: iTrack): iTrack => {
  if (track.ID) {
    return track;
  }
  const generatedId = generateTrackID(track);
  if (generatedId) {
    return { ...track, ID: generatedId };
  }
  if (track._id) {
    return { ...track, ID: track._id };
  }
  if (track.SpotifyID) {
    return { ...track, ID: track.SpotifyID };
  }
  return track;
};

export const ensureTrackIds = (tracks: iTrack[]): iTrack[] => {
  return tracks.map(ensureTrackId);
};
